import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";
import {
  getPreferredLanguage,
  persistPreferredLanguage,
} from "./utils/userPreferences";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getPreferredLanguage() || undefined,
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    detection: {
      order: ["querystring", "localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "wifiads-language",
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    backend: { loadPath: "/locales/{{lng}}/translation.json" },
  });

function updateDocumentLocale(language) {
  axios.defaults.headers.common["Accept-Language"] = language || "es";
  if (typeof document === "undefined") return;
  document.documentElement.lang = language || "es";
  document.documentElement.dir = i18n.dir(language);
}

i18n.on("languageChanged", updateDocumentLocale);
i18n.on("initialized", () => updateDocumentLocale(i18n.resolvedLanguage));

export async function setApplicationLanguage(language) {
  const normalized = persistPreferredLanguage(language);
  await i18n.changeLanguage(normalized);
  return normalized;
}

export default i18n;
